export default __webpack_public_path__ + "static/media/330_business06-en-mobile.c107a0b0.png";